import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './Achievements.css';

const Achievements = () => {
  const [achievements, setAchievements] = useState([]);
  const [stats, setStats] = useState(null);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [achievementsRes, statsRes] = await Promise.all([
        api.get('/gamification/achievements'),
        api.get('/gamification/stats'),
      ]);
      setAchievements(achievementsRes.data);
      setStats(statsRes.data);
    } catch (error) {
      console.error('Error fetching achievements:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredAchievements = achievements.filter((a) => {
    if (filter === 'earned') return a.earned;
    if (filter === 'locked') return !a.earned;
    return true;
  });

  const earnedCount = achievements.filter((a) => a.earned).length;
  const totalPoints = achievements
    .filter((a) => a.earned)
    .reduce((sum, a) => sum + a.points, 0);

  if (loading) {
    return <div className="loading">Loading achievements...</div>;
  }

  return (
    <div className="page achievements-page">
      <div className="container">
        <section className="achievements-hero">
          <div className="hero-content">
            <p className="eyebrow">Milestones</p>
            <h1>Achievements</h1>
            <p>
              Track your learning streak, unlock themed badges, and level up with
              every challenge completed.
            </p>
          </div>
          <div className="hero-card">
            <div>
              <span className="label">Level</span>
              <p className="hero-value">Level {stats?.level || 1}</p>
            </div>
            <div>
              <span className="label">Points to next</span>
              <p className="hero-value">
                {stats?.points_to_next_level || 0} pts
              </p>
            </div>
            <div>
              <span className="label">Achievements earned</span>
              <p className="hero-value">
                {earnedCount}/{achievements.length}
              </p>
            </div>
          </div>
        </section>

        <div className="achievement-stats">
          <div className="stat-card">
            <span className="stat-icon">🏆</span>
            <div>
              <p className="stat-value">
                {earnedCount}/{achievements.length}
              </p>
              <p className="stat-label">Achievements unlocked</p>
            </div>
          </div>
          <div className="stat-card">
            <span className="stat-icon">⭐</span>
            <div>
              <p className="stat-value">{totalPoints.toLocaleString()}</p>
              <p className="stat-label">Points collected</p>
            </div>
          </div>
          <div className="stat-card">
            <span className="stat-icon">🔥</span>
            <div>
              <p className="stat-value">
                {achievements.length - earnedCount}
              </p>
              <p className="stat-label">Waiting to be unlocked</p>
            </div>
          </div>
        </div>

        <div className="filter-tabs">
          <button
            className={filter === 'all' ? 'active' : ''}
            onClick={() => setFilter('all')}
          >
            All ({achievements.length})
          </button>
          <button
            className={filter === 'earned' ? 'active' : ''}
            onClick={() => setFilter('earned')}
          >
            Earned ({earnedCount})
          </button>
          <button
            className={filter === 'locked' ? 'active' : ''}
            onClick={() => setFilter('locked')}
          >
            Locked ({achievements.length - earnedCount})
          </button>
        </div>

        <div className="achievements-grid">
          {filteredAchievements.map((achievement) => (
            <article
              key={achievement.id}
              className={`achievement-card ${
                achievement.earned ? 'earned' : 'locked'
              }`}
            >
              <div className="achievement-icon">{achievement.icon}</div>
              <div className="achievement-content">
                <h3>{achievement.name}</h3>
                <p className="description">{achievement.description}</p>
                <div className="achievement-meta">
                  <span className="points">+{achievement.points} pts</span>
                  {achievement.earned ? (
                    <span className="earned-date">
                      Earned{' '}
                      {new Date(achievement.earned_at).toLocaleDateString()}
                    </span>
                  ) : (
                    <div className="progress-container">
                      <div className="progress-bar">
                        <div
                          className="progress-fill"
                          style={{ width: `${achievement.progress}%` }}
                        ></div>
                      </div>
                      <span className="progress-text">
                        {achievement.current}/{achievement.target}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              {achievement.earned && <div className="earned-badge">✓</div>}
            </article>
          ))}
        </div>

        {filteredAchievements.length === 0 && (
          <div className="empty-state">
            <p>No achievements found for this filter.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Achievements;
